/* @flow */

import { combineReducers } from 'redux';

import appAllBraindatesReducer from './appAllBraindateReducer';
import appJoinedBraindateReducer from './appJoinedBraindateReducer';

// $FlowIssue
const appBraindatesReducer = combineReducers({
  all: appAllBraindatesReducer,
  joined: appJoinedBraindateReducer,
});

export default appBraindatesReducer;
